import { call, put } from 'redux-saga/effects'

import actions from 'actions'
import api from 'services'
import { fetchData, fetchEntity, fetchPaginate } from 'utils/sagas'
import { now } from 'utils/datetime'

const { eventGroups, setupforms } = actions

const fetchEventGroups = fetchEntity.bind(null, eventGroups, api.fetchEventGroups)
const fetchPastEventGroups = fetchEntity.bind(null, eventGroups, api.fetchPastEventGroups)
const fetchSetupforms = fetchData.bind(null, setupforms, api.fetchSetupforms)

export function* homeLoadPage({ partnerId }) {
  yield call(fetchEventGroups, partnerId)
  yield put(actions.homeLoadPastEventGroups(partnerId))
  yield call(fetchSetupforms, partnerId)
}

export function* homeLoadPastEventGroups({ partnerId, nextPage }) {
  yield fetchPaginate(fetchPastEventGroups, 'partnerPastEventGroups', partnerId, nextPage, now())
}



/** WEBPACK FOOTER **
 ** ./src/sagas/home/home-sagas.js
 **/